<script setup lang="ts">
import { usePlannerCategories } from "@/composables/usePlannerCategories";
import { usePlannerTemplateForm } from "@/stores/plannerTemplateFormStore";
import LoadingDialog from "@/stories/dialogs/LoadingDialog.vue";
import TagSelectorInput from "@/stories/form/TagSelectorInput/TagSelectorInput.vue";
import FormContent from "@/views/planner/dialogs/templates/form/FormContent.vue";
import { computed } from "vue";

const store = usePlannerTemplateForm();
const { loading, categoriesList, noCategoryItem } = usePlannerCategories();

const selectableCategories = computed(() => {
  return [noCategoryItem.value, ...categoriesList.value];
});
</script>

<template>
  <FormContent>
    <div class="h600 text-neutral1000 pb-6">
      {{ $t("templates.choose_category") }}
    </div>
    <TagSelectorInput
      name="category"
      :items="selectableCategories"
      :validation="store.validation"
      :allowDeselect="false"
      v-model="store.form.category"
    />
  </FormContent>
  <LoadingDialog v-if="loading === 'loading'" />
</template>
